import { useRequest } from 'ahooks'
import { Form, Modal, ModalProps } from 'antd'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { routes } from '@/router'
import { Project } from '@/schemas'

import { ProjectForm, ProjectFormType, ProjectValues } from './project-form.component'

interface ProjectEditProps extends ModalProps {
  originProject: Project
  onCancel: () => void
}

export const ProjectClone: React.FC<ProjectEditProps> = ({ originProject, ...props }) => {
  const { t } = useTranslation()
  const [form] = Form.useForm<ProjectValues>()
  const history = useHistory()

  React.useEffect(() => {
    form.setFieldsValue({
      name: originProject.name + t('project.clone.name.suffix'),
      email: originProject.email,
      range: [
        originProject.startDate ? moment(originProject.startDate) : null,
        originProject.endDate ? moment(originProject.endDate) : null,
      ],
      departmentId: originProject.departmentId,
      source: originProject.source,
      industry:
        originProject.industryId && originProject.scenarioId
          ? [originProject.industryId, originProject.scenarioId]
          : undefined,
      classification: originProject.classification,
      priority: originProject.priority,
      projectType: originProject.projectType,
      background: originProject.background,
      goal: originProject.goal,
      challenge: originProject.challenge,
      goalDescription: originProject.goalDescription,
      checkStandard: originProject.checkStandard,
      releaseJiraKey: originProject.releaseJiraKey,
      releaseNumber: originProject.releaseNumber,
      releaseType: originProject.releaseType,
      cloneUserRole: true,
    })
  }, [originProject])

  const { run, loading } = useRequest(
    (data) => ({
      url: '/api/project/cloneProject',
      method: 'post',
      data: {
        ...data,
        originSelfId: originProject.selfId,
      },
    }),
    {
      manual: true,
      onSuccess: (data) => {
        props.onCancel()
        history.push(routes.project.page(data.selfId))
      },
    }
  )

  return (
    <Modal
      maskClosable={false}
      title={`${t('project.clone.button.title')}`}
      okText={t('save')}
      okButtonProps={{ loading }}
      onOk={() => form.submit()}
      {...props}
    >
      <ProjectForm jql={originProject.jql || undefined} form={form} type={ProjectFormType.CLONE} onSubmit={run} />
    </Modal>
  )
}
